import * as ShedsAPI from '../common/helpers/ShedsAPI';
import { User } from '../pages/users/User.type';

export const get = ({ accountId }: { accountId: number }): Promise<User> => {
	return ShedsAPI.get('api', `/${accountId}/stats`, {});
};
